// src/components/pages/portfolios/hooks/usePeriodSelectors.js

import { useState, useCallback } from 'react';

// 기간 선택 인덱스 상태와 변경 핸들러를 관리하는 훅
// 💡 requestSort와 sortConfig를 인자로 받습니다.
export function usePeriodSelectors(t, PERIODS_KEYS, requestSort, sortConfig) {
  
  // 1. 전체 라벨 정의 (수익률, 샤프, 소르티노, 칼마용)
  const PERIODS_LABELS = ['1W', '2W', '1M', '3M', '6M', '1Y', t('portfolios.period.all')];
  
  // 2. MDD 및 변동성(Vol) 전용 기간 제한 (1w, 2w 제외)
  const LIMITED_PERIOD_KEYS = ['1W', '2W', '1m', '3m', '6m', '1y', t('portfolios.period.all')];
  
  // MDD와 Vol이 사용할 라벨 배열 생성
  const LIMITED_LABELS = PERIODS_KEYS.reduce((labels, key, index) => {
      if (LIMITED_PERIOD_KEYS.includes(key)) {
          labels.push(PERIODS_LABELS[index]);
      }
      return labels;
  }, []);

  
  // 기간 인덱스 상태 (기본값 1Y = 인덱스 3)
  const [returnIndex, setReturnIndex] = useState(0);
  const [ddIndex, setDdIndex] = useState(2);
  const [volIndex, setVolIndex] = useState(2);
  const [sharpeIndex, setSharpeIndex] = useState(2);
  const [calmarIndex, setCalmarIndex] = useState(2);
  const [sortinoIndex, setSortinoIndex] = useState(2);
  

  // 현재 인덱스에 해당하는 기간 키('1y', '3m' 등)를 가져오는 유틸리티
  const getPeriodKey = useCallback((index) => {
    const key = PERIODS_KEYS[index];
    if (key) return key;
    return '1y'; // 유효하지 않으면 기본값 '1y'
  }, [PERIODS_KEYS]);

  // 재사용 가능한 변경 핸들러 팩토리
  // 3. 변경 핸들러 수정 (어떤 라벨 리스트를 사용하는지 인자로 받음)
  const createChangeHandler = (setIndex, baseKey, labelsArray = PERIODS_LABELS) => (e) => { 
    const val = e.target.value;
    // 클릭한 라벨이 전체 리스트에서 몇 번째인지 정확히 찾아야 함
    const globalIdx = PERIODS_LABELS.indexOf(val); 
    
    if (globalIdx !== -1) { 
      setIndex(globalIdx); 
      
      if (sortConfig && sortConfig.key.startsWith(baseKey)) {
        const newSortKey = `${baseKey}_${PERIODS_KEYS[globalIdx]}`;
        requestSort(newSortKey);
      }
    }
  };

  return {
    PERIODS_LABELS,
    LIMITED_LABELS,
    returnIndex, ddIndex, sharpeIndex, calmarIndex, sortinoIndex, volIndex,
    getPeriodKey,
    handleReturnChange: createChangeHandler(setReturnIndex, 'ret'),
    handleSharpeChange: createChangeHandler(setSharpeIndex, 'sharpe'),
    handleCalmarChange: createChangeHandler(setCalmarIndex, 'calmar'),
    handleSortinoChange: createChangeHandler(setSortinoIndex, 'sortino'),
    handleDdChange: createChangeHandler(setDdIndex, 'mdd', LIMITED_LABELS),
    handleVolChange: createChangeHandler(setVolIndex, 'vol', LIMITED_LABELS),
  };
}